import * as apiFactory from "./ApiFactory";
import { Api } from "./Api";

import type { BrandViewerConfig } from "@/models/BrandViewerConfig";

export async function Get(clientName: string, brand: string, lensCode: string): Promise<BrandViewerConfig> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<BrandViewerConfig>(`api/brandclientuiconfig/${clientName}/${brand}?lensCode=${lensCode}`);
}

export async function Post(clientName: string, brand: string, lensCode: string, config: BrandViewerConfig) {
  const client: Api = await apiFactory.WithBearer();
  return await client.post(`api/brandclientuiconfig/${clientName}/${brand}?lensCode=${lensCode}`, config);
}
